import Vue from 'vue'
import calc from '@src/calc'

export const state = {
  all: [],
}

export const getters = {
  getIndex: (state) => (extra) =>
    state.all.findIndex((item) => item.id === extra.id),
  getItem: (state, getters) => (extra) => {
    const index = getters.getIndex(extra)
    return state.all[index]
  },
  isEmpty: (state) => state.all.length < 1,
  getTotalExtra: (state) => (extra) =>
    state.all
      .filter((item) => item.id === extra.id)
      .reduce((prev, curr) => (prev += curr.qty), 0),
  cartItems: (state, getters, rootState, rootGetters) =>
    state.all.map((item) => {
      const extra = rootGetters['extras/getExtraByCart'](item)

      return {
        id: item.id,
        qty: item.qty,
        name: `${extra.name}`,
        date: item.date,
        time: item.time,
        price: calc.multiplyRate(extra.rate, item.qty),
      }
    }),
  payload: (state, getters) =>
    getters.cartItems.map((item) => ({
      id: item.id,
      qty: item.qty,
      date: item.date,
      time: item.time,
      price: calc.payloadPrice(item.price),
    })),
  totalPriceInCart: (state, getters) =>
    getters.cartItems.reduce(
      (pre, cur) => {
        if (!pre.currency) pre.currency = cur.price.currency

        pre.gross += cur.price.gross
        pre.discount += cur.price.discount
        pre.tax += cur.price.tax
        pre.service += cur.price.service
        pre.net += cur.price.net

        return pre
      },
      { currency: null, gross: 0, discount: 0, tax: 0, service: 0, net: 0 }
    ),
}

export const actions = {
  updateExtraCart({ commit, getters }, { extra, qty, date, time }) {
    const index = getters.getIndex(extra)
    const item = {
      id: extra.id,
      qty,
      date,
      time,
    }

    if (index < 0) {
      return commit('ADD_EXTRA_ITEM', item)
    }

    if (qty === 0) {
      return commit('DELETE_EXTRA_ITEM', index)
    }

    return commit('UPDATE_EXTRA_ITEM_QTY', { index, item })
  },
  clearCart: {
    root: true, // triggered by global action: clearAllCart
    handler({ commit }) {
      commit('CLEAR_CART')
    },
  },
}

export const mutations = {
  ADD_EXTRA_ITEM(state, item) {
    state.all.push(item)
  },
  DELETE_EXTRA_ITEM(state, index) {
    state.all.splice(index, 1)
  },
  UPDATE_EXTRA_ITEM_QTY(state, { index, item }) {
    Vue.set(state.all, index, item)
  },
  CLEAR_CART(state) {
    state.all = []
  },
}
